export class FileUploaded {
  contentType: string;
  description: string;
  id: string;
  url: string;
  name: string;
  size: number;
}

export enum FileUploadType {
  CSV = "csv",
  PNG = "png",
  JPG = "jpg",
  pdf = "pdf",
  XLSX = "xlsx"
}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/file-uploaded.ts